import { render, staticRenderFns } from "./AccidentContent.vue?vue&type=template&id=a8eeceb4&"
import script from "./AccidentContent.vue?vue&type=script&lang=js&"
export * from "./AccidentContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports